import Cookies from 'js-cookie';
import { ResponseCookie } from 'next/dist/compiled/@edge-runtime/cookies';

import { CONFIG } from '@/config';

export class CookiesUtils {
  static logout() {
    CookiesUtils.delete(CONFIG.authSessionCookieName);
  }

  static delete(name: string) {
    Cookies.remove(name);
  }

  static set(name: string, value: string, options?: Cookies.CookieAttributes) {
    const defaultOptions = this.getOptions();
    const mergedOptions = { ...defaultOptions, ...options };
    Cookies.set(name, value, mergedOptions);
  }

  static get(name: string) {
    return Cookies.get(name);
  }

  static getDomain() {
    const env = process.env.NODE_ENV;
    if (env === 'development') return undefined;

    return `.${CONFIG.host.split('.').slice(-2).join('.')}`;
  }

  static getOptions(options?: Cookies.CookieAttributes) {
    return {
      path: '/',
      domain: this.getDomain(),
      expires: 30,
      ...options
    };
  }

  static getSsrOptions(
    options?: Partial<ResponseCookie>
  ): Partial<ResponseCookie> {
    return {
      path: '/',
      domain: this.getDomain(),
      expires: 30,
      ...options
    };
  }
}
